/*@jsxRuntime classic @jsx React.createElement @jsxFrag React.Fragment*/
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import React from "react";
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    a: "a",
    ul: "ul",
    li: "li",
    img: "img"
  }, _provideComponents(), props.components);
  return React.createElement(React.Fragment, null, React.createElement(_components.h2, {
    id: "click-below-to-get-your-bonuses"
  }, React.createElement(_components.a, {
    href: "#click-below-to-get-your-bonuses"
  }, "Click below to get your bonuses")), "\n", React.createElement(_components.ul, null, "\n", React.createElement(_components.li, null, React.createElement(_components.img, {
    src: "https://goviral.growthtools.com/images/bullets/1.png",
    alt: "Why Programmers Work at Night",
    title: "Why Programmers Work at Night"
  }), " Free copy of Why Programmers Work at Night ", React.createElement("span", {
    role: "img",
    "aria-label": "owl"
  }, "🦉"), " ", React.createElement("br")), "\n", React.createElement(_components.li, null, React.createElement(_components.a, {
    href: "https://leanpub.com/nightowls/c/blog-freebie"
  }, "Get the book")), "\n", React.createElement(_components.li, null, React.createElement(_components.img, {
    src: "https://goviral.growthtools.com/images/bullets/2.png",
    alt: "Free React Basics",
    title: "Free React Basics"
  }), " 29 videos on React Basics ", React.createElement("span", {
    role: "img",
    "aria-label": "film"
  }, "🎥"), " ", React.createElement("br")), "\n", React.createElement(_components.li, null, React.createElement(_components.a, {
    href: "https://www.youtube.com/playlist?list=PLF8WgaD4xmjWuh7FTYTealxehOuNor_2S"
  }, "Watch now")), "\n"));
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? React.createElement(MDXLayout, props, React.createElement(_createMdxContent, props)) : _createMdxContent(props);
}
export default MDXContent;
